import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import Typography from 'fuse-ui/components/Typography';

const styles = theme => ( {
    chicletCount: {
        color: theme.palette.primary[800],
        cursor: 'pointer',
        textDecoration: 'none'
    },
} );

const ChicletNumbers = ( { automationId, bottom, classes, middle, path, top } ) => {
    return (
        <React.Fragment>
            <Typography variant="overline" data-automation-id={`${automationId}-top`}>
                {top}
            </Typography>
            {
                path ? (
                    <Typography
                        className={classes.chicletCount}
                        component={Link}
                        data-automation-id={`${automationId}-middle`}
                        to={path}
                        variant="h4"
                    >
                        {middle}
                    </Typography>
                ) : (
                    <Typography
                        className={classes.chicletCount}
                        variant="h4"
                        data-automation-id={`${automationId}-middle`}
                    >
                        {middle}
                    </Typography>
                )}
            <Typography data-automation-id={`${automationId}-bottom`}>
                {bottom}
            </Typography>
        </React.Fragment>
    );
};

ChicletNumbers.defaultProps = {
    bottom: '',
    middle: '',
    top: '',
};

ChicletNumbers.propTypes = {
    automationId: PropTypes.string.isRequired,
    bottom: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number
    ] ).isRequired,
    classes: PropTypes.object.isRequired,
    middle: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number
    ] ).isRequired,
    path: PropTypes.string,
    top: PropTypes.oneOfType( [
        PropTypes.string,
        PropTypes.number
    ] ).isRequired,
};
export default withStyles( styles )( ChicletNumbers );
